/**
 * escapeOpenSearchQuery
 *
 * @param {string} query
 * @returns {string}
 */
export function escapeOpenSearchQuery(query: string): string {
  return typeof query === 'string'
    ? query.replace(/(>|<)/g, '').replace(/(\+|-|=|&&|\|\||!|\(|\)|\{|\}|\[|\]|\^|"|~|\*|\?|:|\\|\/)/g, '\\$&')
    : query;
}
